import React, { useState } from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  MenuItem,
  Paper,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useParams } from "react-router-dom";
import DiscountInfo from "../Components/FillerComponents/taxitwo";

const TourForm = () => {
  const { tourTitle } = useParams();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    travellers: "",
    adults: "",
    children: "",
    carType: "",
    pickupDate: null,
    dropoffDate: null,
  });

  const carOptions = ["Sedan", "SUV", "Traveller 12 Seater"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `Hello, I would like to book a tour.

Tour: ${tourTitle}
Name: ${formData.fullName}
Phone: ${formData.phone}
Email: ${formData.email}
Travellers: ${formData.travellers}
Adults: ${formData.adults}
Children: ${formData.children}
Car Type: ${formData.carType}
Pickup Date: ${formData.pickupDate?.format("DD/MM/YYYY") || "Not selected"}
Dropoff Date: ${formData.dropoffDate?.format("DD/MM/YYYY") || "Not selected"}`;

    window.open(
      `https://wa.me/8435541370?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ background: "#f9fafb", py: 6 }}>
        <Paper
          elevation={0}
          sx={{
            maxWidth: 720,
            mx: "auto",
            p: { xs: 3, md: 4 },
            borderRadius: 4,
            border: "1px solid #e5e7eb",
            background:
              "linear-gradient(180deg,#ffffff,#f0fdfa)",
          }}
        >
          {/* HEADER */}
          <Typography
            variant="h4"
            fontWeight={900}
            textAlign="center"
            mb={1}
          >
            Book Your Tour
          </Typography>

          <Typography
            textAlign="center"
            color="text.secondary"
            mb={3}
          >
            Fill the details below and our travel expert will connect
            with you shortly on WhatsApp.
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* BASIC INFO */}
              <Grid item xs={12}>
                <TextField
                  label="Full Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Phone Number"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Email Address"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              {/* TRAVEL DETAILS */}
              <Grid item xs={12} md={4}>
                <TextField
                  label="Total Travellers"
                  name="travellers"
                  type="number"
                  value={formData.travellers}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  label="Adults"
                  name="adults"
                  type="number"
                  value={formData.adults}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  label="Children"
                  name="children"
                  type="number"
                  value={formData.children}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  label="Preferred Vehicle"
                  name="carType"
                  value={formData.carType}
                  onChange={handleChange}
                  fullWidth
                  required
                >
                  {carOptions.map((car) => (
                    <MenuItem key={car} value={car}>
                      {car}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* DATES */}
              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Pickup Date"
                  value={formData.pickupDate}
                  onChange={(date) =>
                    handleDateChange("pickupDate", date)
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Dropoff Date"
                  value={formData.dropoffDate}
                  onChange={(date) =>
                    handleDateChange("dropoffDate", date)
                  }
                  renderInput={(params) => (
                    <TextField {...params} fullWidth />
                  )}
                />
              </Grid>

              {/* CTA */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  size="large"
                  sx={{
                    mt: 1,
                    fontWeight: 800,
                    py: 1.4,
                    background:
                      "linear-gradient(135deg,#0f766e,#14b8a6)",
                  }}
                  variant="contained"
                >
                  Send Enquiry on WhatsApp
                </Button>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  textAlign="center"
                  fontSize={13}
                  color="text.secondary"
                >
                  🔒 Your details are safe. No spam, only genuine travel support.
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Paper>

        <DiscountInfo />
      </Box>
    </LocalizationProvider>
  );
};

export default TourForm;
